const async = function(callback) {
    return Promise.resolve().then(callback);
};

export default async;



//////////////////
// WEBPACK FOOTER
// /Users/Jovan/TitanNanoDE/node_modules/@af-modules/databinding/node_modules/application-frame/core/async.js
// module id = 17
// module chunks = 0